<script>
  import SongCodeBlock from "$lib/components/SongCodeBlock.svelte";

  let {
    title,
    subtitle,
    filename,
    code,
  } = $props();
</script>

<section class="border-b border-[#3a3a4a]">
  <div class="max-w-4xl mx-auto px-4 py-16">
    <div class="text-center mb-8">
      <p class="text-[#888890] text-xs uppercase tracking-widest mb-3">── EXAMPLE ──</p>
      <h2 class="text-2xl md:text-3xl font-bold text-[#e8e8ec] mb-4">
        {title}
      </h2>
      <p class="text-[#a0a0a8] text-sm">
        {subtitle}
      </p>
    </div>

    <div class="h-[400px]">
      <SongCodeBlock {code} {filename} mode="dark" />
    </div>
  </div>
</section>
